<h1>{{'users.rights.title' | translate}}</h1>

<div class="card p-3 gap-3">
    <button class="btn link-btn back-btn align-self-start" (click)="redirectToListHandler()" >
        <i class="app-icon icon icon-arrow-left icon-xl me-2"></i>
        <span>{{'users.rights.backToListLabel' | translate}}</span>
    </button>

    <ng-container *ngIf="!userWithoutRoles && dataLoaded">
        <div class="d-flex align-items-center gap-2 rights-generic-item-container" >
            <i class="app-icon icon icon-warning-circle icon-xl me-2"></i>
            <span>{{'users.rights.noRightsWarning' | translate}}</span>
        </div>
    
        <form #rightsConfiguratorForm="ngForm">
            <ng-container *ngFor="let feature of featuresAndRights">
                <div class="d-flex flex-column">
                    <div class="d-flex align-items-center justify-content-between rights-generic-item-container rights-container">
                        <span>{{feature.value}}</span>
            
                        <div class="d-flex gap-2">
                            <ng-container *ngFor="let rightGroup of feature.rightGroups; let isLast = last">
                                <label 
                                    class="d-flex align-items-center justify-content-center gap-3 cursor-pointer user-select-none fw-bold btn outline-btn outline-primary"
                                    for="{{feature.id}}_{{rightGroup.id}}">
                                    <input 
                                        type="radio" 
                                        kendoRadioButton
                                        size="large"
                                        id="{{feature.id}}_{{rightGroup.id}}" 
                                        name="{{feature.id}}" 
                                        [value]="rightGroup.isSelectedOption"
                                        [checked]="rightGroup.isSelectedOption"
                                        (change)="mapRightGroupToSaveModelHandler(feature.id, rightGroup.id)"
                                        />
                                     <span>{{rightGroup.value}}</span>
                                </label>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </ng-container>
        </form>
    </ng-container>

    <div class="d-flex flex-column justify-content-center" *ngIf="userWithoutRoles && dataLoaded">
        <h3 class="text-center text-secondary my-4">{{'users.rights.userWithoutRoles' | translate}}</h3>
        <no-records-placeholder></no-records-placeholder>
    </div>

    <div class="d-flex justify-content-center">
        <button class="btn btn-primary text-light d-flex justify-content-center" (click)="saveUserPermissionsHandler()">
            {{'common.save' | translate}}
        </button>
    </div>
</div>